import { createReducer } from '@reduxjs/toolkit';
import { logoutAction } from '../actions/LogoutAction'; // path as needed

const initialState = {};

const LogoutReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(logoutAction, () => initialState) 
    .addDefaultCase((state) => state);
});

export default LogoutReducer;
